<template>
  <section class="row">
    <div class="col-12 col-md-9 mx-auto">
      <div class="h5">
        Modifier l'effectif de votre entreprise
      </div>
      <div class="text-gray-600 my-3">
        Vous pouvez valider votre modification et passer à la signature des
        déclarations, ou bien poursuivre vos modifications.
      </div>
    </div>
    <div class="col-12 col-md-9 mx-auto">
      <v-input
        input-id="effectif"
        label="Nombre de salariés"
        mask="number"
        module-name="contract"
        getter-name="get"
        setter-name="updateSubscription"
        placeholder="10"
        :getter-function="({ risk : { effectif } }) => effectif"
        path="risk.effectif"
      />
    </div>
  </section>
</template>
<script>
import Input2 from '@/components/common/input/Input2.vue';

export default {
  name: 'CustomisationEffectif',
  components: {
    'v-input': Input2,
  },
};
</script>
